import { sb } from '../../../supabase.ts';
import { escapeHtml } from '../../../main.ts';

export async function renderOtherSchoolResultDetailsPage(app: HTMLElement): Promise<void> {
  const tableNameExam = 'exam_others_school';

  // Get student ID from URL query parameters
  const urlParams = new URLSearchParams(window.location.search);
  const targetIID = urlParams.get('iid') || '';

  // Setup report card CSS and shell matching premium typography
  app.innerHTML = `
    <style>
      .details-wrap {
        background: #ffffff;
        color: #111111;
        font-family: 'Inter', 'Segoe UI', Roboto, sans-serif;
        min-height: 100vh;
        padding: 30px;
        box-sizing: border-box;
      }
      .actions-panel {
        display: flex;
        gap: 12px;
        margin-bottom: 24px;
      }
      .btn {
        padding: 10px 18px;
        font-size: 14px;
        border-radius: 6px;
        font-weight: 700;
        cursor: pointer;
        border: none;
        transition: opacity 0.2s;
        color: #0f172a;
        text-decoration: none;
        display: inline-flex;
        align-items: center;
        gap: 6px;
      }
      .btn.primary {
        background: #10b981;
      }
      .btn.secondary {
        background: #2196f3;
      }
      .btn.dark {
        background: #f1f5f9;
      }
      .marksheet-box {
        border: 2px solid #000000;
        padding: 24px;
        border-radius: 12px;
        background: #ffffff;
        max-width: 800px;
        margin: 0 auto;
        box-shadow: 0 4px 20px rgba(0,0,0,0.06);
        position: relative;
      }
      .pad-header img {
        max-width: 100%;
        height: auto;
        display: block;
        margin: 0 auto 12px;
      }
      .exam-title {
        font-size: 24px;
        font-weight: 800;
        color: #d2197f;
        text-align: center;
        margin-bottom: 16px;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      .student-meta {
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
        gap: 12px;
        margin-bottom: 24px;
        font-size: 14px;
        border-bottom: 1px solid rgba(0, 0, 0, 0.1);
        padding-bottom: 16px;
      }
      .student-meta p {
        margin: 4px 0;
      }
      .student-meta strong {
        color: #000000;
      }
      .report-table {
        width: 100%;
        border-collapse: collapse;
        margin-bottom: 24px;
        border: 2px solid #000000;
      }
      .report-table th, .report-table td {
        padding: 10px 12px;
        text-align: center;
        border: 1px solid #000000;
        font-size: 13.5px;
      }
      .report-table th {
        background: #f1f3f5;
        font-weight: 700;
        color: #000000;
      }
      .report-table td:first-child, .report-table th:first-child {
        text-align: left;
        font-weight: 700;
      }
      .highlight-box {
        display: flex;
        gap: 12px;
        flex-wrap: wrap;
        justify-content: center;
        margin-top: 16px;
        margin-bottom: 24px;
      }
      .highlight-item {
        min-width: 110px;
        padding: 8px 12px;
        border-radius: 6px;
        text-align: center;
        border: 1px solid rgba(0, 0, 0, 0.1);
      }
      .highlight-title {
        font-size: 11px;
        font-weight: 700;
        color: #666;
        text-transform: uppercase;
      }
      .highlight-val {
        font-size: 18px;
        font-weight: 850;
        margin-top: 4px;
      }
      .footer-section {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        margin-top: 24px;
        font-size: 12px;
        border-top: 1px dashed rgba(0, 0, 0, 0.05);
        padding-top: 16px;
      }
      .qr-block img {
        width: 120px;
        height: 120px;
        border: 1px solid #000000;
        padding: 2px;
        background: #ffffff;
      }
      .signature-block {
        text-align: center;
        margin-top: 50px;
        border-top: 1px solid #000000;
        width: 160px;
        padding-top: 6px;
        font-weight: 700;
      }
      .status-banner {
        text-align: center;
        padding: 50px;
        font-size: 16px;
        color: #666;
      }
      @media print {
        .actions-panel {
          display: none !important;
        }
        .details-wrap {
          padding: 0;
        }
        .marksheet-box {
          border: none;
          box-shadow: none;
          padding: 0;
        }
      }
    </style>

    <div class="details-wrap">
      <div class="actions-panel">
        <a href="/other_school/result/list" class="btn dark">⬅ Back to List</a>
        <button id="printBtn" class="btn primary">Print Marksheet</button>
        <button id="downloadPdfBtn" class="btn secondary">Download PDF</button>
      </div>

      <div id="loadingBanner" class="status-banner">
        🔄 Loading detailed report card...
      </div>

      <div id="marksheetWrapper" style="display: none;">
        <div id="marksheetBox" class="marksheet-box">
          <div class="pad-header">
            <img src="/pad.png" alt="Feni Model High School Header Pad" onerror="this.style.display='none'" />
          </div>

          <div id="examTitle" class="exam-title">-</div>

          <div class="student-meta">
            <div>
              <p>Name: <strong id="mName">-</strong></p>
              <p>Father's Name: <span id="mFatherName">-</span></p>
            </div>
            <div>
              <p>Class: <strong id="mClass">-</strong> | Section: <strong id="mSection">-</strong></p>
              <p>Roll: <strong id="mRoll">-</strong> | Student IID: <strong id="mIID">-</strong></p>
            </div>
          </div>

          <table class="report-table">
            <thead>
              <tr>
                <th>Subject</th>
                <th>CQ</th>
                <th>MCQ</th>
                <th>Practical</th>
                <th>Total</th>
                <th>GPA</th>
              </tr>
            </thead>
            <tbody id="subjectsTableBody"></tbody>
          </table>

          <!-- Highlight boxes -->
          <div class="highlight-box">
            <div class="highlight-item" style="background: #e8f5e9;">
              <div class="highlight-title" style="color: #2e7d32;">GPA</div>
              <div id="valGPA" class="highlight-val" style="color: #1b5e20;">-</div>
            </div>
            <div class="highlight-item" style="background: #fff8e1;">
              <div class="highlight-title" style="color: #ef6c00;">Total Marks</div>
              <div id="valTotal" class="highlight-val" style="color: #e65100;">-</div>
            </div>
            <div class="highlight-item" style="background: #f3e5f5;">
              <div class="highlight-title" style="color: #6a1b9a;">Average</div>
              <div id="valAverage" class="highlight-val" style="color: #4a148c;">-</div>
            </div>
            <div class="highlight-item" style="background: #fce4ec;">
              <div class="highlight-title" style="color: #c2185b;">Class Rank</div>
              <div id="valRank" class="highlight-val" style="color: #880e4f;">-</div>
            </div>
          </div>

          <div class="footer-section">
            <div style="flex: 1; padding-right: 20px;">
              <p style="font-weight: bold; margin-bottom: 6px;">নির্দেশনা :</p>
              <p style="margin: 0; line-height: 1.4;">
                নতুন শিক্ষাবর্ষে জানুয়ারির ১ম সপ্তাহে নতুন শ্রেণিতে ভর্তি হয়ে নতুন বই সংগ্রহ করতে হবে। ভর্তির সময় মার্কশীটের ফটোকপি অবশ্যই আনতে হবে।
              </p>
              <p style="margin: 4px 0 0; line-height: 1.4;">
                পূর্বানুমতি ছাড়া একটানা ১০ দিন ক্লাসে অনুপস্থিত থাকলে হাজিরা বহিতে নাম কাটা যাবে।
              </p>
              <p style="margin-top: 12px; font-size: 11px; color: #666;">
                Verify this report card authenticity by scanning the QR code.
              </p>
            </div>

            <div style="display: flex; gap: 24px; align-items: flex-end;">
              <div class="qr-block" id="qrBlock"></div>
              <div class="signature-block">Principal Signature</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  `;

  const loadingBanner = document.getElementById('loadingBanner') as HTMLDivElement;
  const marksheetWrapper = document.getElementById('marksheetWrapper') as HTMLDivElement;
  const printBtn = document.getElementById('printBtn') as HTMLButtonElement;
  const downloadPdfBtn = document.getElementById('downloadPdfBtn') as HTMLButtonElement;

  const mName = document.getElementById('mName') as HTMLElement;
  const mFatherName = document.getElementById('mFatherName') as HTMLElement;
  const mClass = document.getElementById('mClass') as HTMLElement;
  const mSection = document.getElementById('mSection') as HTMLElement;
  const mRoll = document.getElementById('mRoll') as HTMLElement;
  const mIID = document.getElementById('mIID') as HTMLElement;
  const examTitle = document.getElementById('examTitle') as HTMLElement;

  const valGPA = document.getElementById('valGPA') as HTMLElement;
  const valTotal = document.getElementById('valTotal') as HTMLElement;
  const valAverage = document.getElementById('valAverage') as HTMLElement;
  const valRank = document.getElementById('valRank') as HTMLElement;

  const subjectsTableBody = document.getElementById('subjectsTableBody') as HTMLTableSectionElement;
  const qrBlock = document.getElementById('qrBlock') as HTMLDivElement;

  // Clean raw header values
  function cleanHeaderKey(h: string): string {
    return String(h || '')
      .replace(/\*/g, '')
      .replace(/"/g, '')
      .toLowerCase()
      .trim()
      .replace(/\s+/g, '_')
      .replace(/[^\w_]/g, '_')
      .replace(/_+/g, '_')
      .replace(/^_|_$/g, '');
  }

  // Safe accessor helper
  function getStudentValueByHeader(student: any, hdr: string): string {
    if (!hdr) return '';
    const original = String(hdr);
    const variants = [
      cleanHeaderKey(original),
      cleanHeaderKey(original.replace(/\s*_\s*/g, '_')),
      cleanHeaderKey(original.replace(/\s{2,}/g, ' ')),
      cleanHeaderKey(original.replace(/\s*-\s*/g, '_'))
    ];
    
    const used = new Set<string>();
    for (const k of variants) {
      if (!k || used.has(k)) continue;
      used.add(k);
      const v = student[k];
      if (v !== null && v !== undefined && String(v).trim() !== '') return String(v).trim();
    }
    return '';
  }

  function generateSubjectMapFromHeaders(hdrs: string[]): Record<string, Record<string, string>> {
    const map: Record<string, Record<string, string>> = {};
    if (!Array.isArray(hdrs)) return map;
    const norm = (s: string) => String(s || '').replace(/\*/g, '').trim();

    const subjects = new Set<string>();
    hdrs.forEach(hRaw => {
      const h = norm(hRaw);
      const m = h.match(/^(.*?)(_CQ|_WRITTEN|_MCQ|_CA|_Practical|_Total|_GPA)$/i);
      if (m) subjects.add(m[1]);
    });

    subjects.forEach(subject => {
      const find = (suffixes: string[]) => hdrs.find(h => {
        const hh = norm(h);
        return suffixes.some(s => hh.endsWith(s) && hh.startsWith(subject));
      }) || '';

      map[subject] = {
        CQ: find(['_CQ', '_WRITTEN']),
        MCQ: find(['_MCQ']),
        CA: find(['_CA']),
        Practical: find(['_Practical']),
        Total: find(['_Total']),
        GPA: find(['_GPA'])
      };
    });

    return map;
  }

  async function loadReportCard() {
    if (!targetIID) {
      loadingBanner.textContent = '❌ No Student ID (iid) was specified in the URL.';
      loadingBanner.style.color = '#ef4444';
      return;
    }

    try {
      const { data, error } = await sb.from(tableNameExam).select('*').eq('iid', targetIID).limit(1);
      if (error) throw error;

      if (!data || data.length === 0) {
        loadingBanner.textContent = `❌ Report card with student IID "${targetIID}" not found in general DB.`;
        loadingBanner.style.color = '#ef4444';
        return;
      }

      const examData = data[0];
      const headers = Object.keys(examData);

      // Normalize row values
      const student: Record<string, any> = {};
      headers.forEach(h => {
        const key = cleanHeaderKey(h);
        student[key] = examData[h] === null ? '' : String(examData[h]).trim();
      });

      // Display Meta info
      mName.textContent = examData.student_name_en || '-';
      mFatherName.textContent = examData.father_name_en || '-';
      mClass.textContent = examData.class_2025 || '-';
      mSection.textContent = examData.section_2025 || '-';
      mRoll.textContent = examData.roll_2025 || '-';
      mIID.textContent = String(examData.iid || '-');
      examTitle.textContent = examData.exam_name_year || 'Examination Marksheet';

      // Summary Highlight boxes
      valGPA.textContent = examData.gpa_final !== null ? parseFloat(examData.gpa_final).toFixed(2) : '-';
      valTotal.textContent = examData.total_mark !== null ? parseFloat(examData.total_mark).toFixed(1) : '-';
      valAverage.textContent = examData.average_mark !== null ? parseFloat(examData.average_mark).toFixed(1) : '-';
      valRank.textContent = examData.class_rank !== null ? String(examData.class_rank) : '-';

      // Render subjects table rows
      const subjMap = generateSubjectMapFromHeaders(headers);
      subjectsTableBody.innerHTML = '';

      Object.entries(subjMap).forEach(([subject, cols]) => {
        const cq = getStudentValueByHeader(student, cols.CQ);
        const mcq = getStudentValueByHeader(student, cols.MCQ);
        const ca = getStudentValueByHeader(student, cols.CA);
        let practical = getStudentValueByHeader(student, cols.Practical);
        const total = getStudentValueByHeader(student, cols.Total);
        const gpa = getStudentValueByHeader(student, cols.GPA);

        // Helper: check empty or zero-ish
        const isEmptyOrZero = (val: string) => {
          const t = String(val || '').trim();
          if (t === '' || t === '-') return true;
          const n = Number(t);
          return !Number.isNaN(n) && n === 0;
        };

        const subjClean = subject.replace(/\*/g, '').toLowerCase();
        const isEnglish1 = /\benglish\b/.test(subjClean) && /\b(1|1st|first)\b/.test(subjClean);
        const isEnglish2 = /\benglish\b/.test(subjClean) && /\b(2|2nd|second)\b/.test(subjClean);
        const isEnglish = isEnglish1 || isEnglish2;

        if (!isEnglish) {
          if ((!practical || practical === '-') && total) {
            const n = (s: string) => isNaN(parseFloat(s)) ? 0 : parseFloat(s);
            const derived = n(total) - (n(cq) + n(mcq) + n(ca));
            if (derived > 0) practical = String(derived);
          }
        } else {
          practical = '';
        }

        const allBlankOrZero = [cq, mcq, ca, practical, total, gpa].every(isEmptyOrZero);
        if (allBlankOrZero) return; // Skip completely blank subject fields

        const tr = document.createElement('tr');
        tr.innerHTML = `
          <td>${subject.replace(/\*/g, '')}</td>
          <td>${cq || '-'}</td>
          <td>${mcq || '-'}</td>
          <td>${isEnglish ? '' : (practical || '-')}</td>
          <td style="font-weight: 700;">${total || '-'}</td>
          <td style="font-weight: 700; color: #2e7d32;">${gpa || '-'}</td>
        `;
        subjectsTableBody.appendChild(tr);
      });

      // Generate Verification QR code image
      const qrBase = 'http://fenimodel.netlify.app/z_others/result/qr_d.html';
      const qrURL = `${qrBase}?IID=${encodeURIComponent(targetIID)}`;
      const qrImgSrc = `https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=${encodeURIComponent(qrURL)}`;

      qrBlock.innerHTML = `
        <a href="${qrURL}" target="_blank" rel="noopener noreferrer">
          <img src="${qrImgSrc}" alt="Verify QR Code" />
        </a>
        <div style="font-size: 8px; font-weight: bold; text-align: center; margin-top: 4px; color: #111;">SCAN TO VERIFY</div>
      `;

      loadingBanner.style.display = 'none';
      marksheetWrapper.style.display = 'block';

    } catch (e: any) {
      loadingBanner.textContent = '❌ Failed to generate report card: ' + e.message;
      loadingBanner.style.color = '#ef4444';
    }
  }

  // Print Report Card Action
  printBtn.onclick = () => {
    window.print();
  };

  // PDF Generation Action
  downloadPdfBtn.onclick = async () => {
    downloadPdfBtn.disabled = true;
    downloadPdfBtn.textContent = '🔄 Preparing PDF...';

    // Lazy load jspdf + html2canvas if not present
    if (!(window as any).html2canvas || !(window as any).jspdf) {
      await new Promise<void>((resolve, reject) => {
        const s1 = document.createElement('script');
        s1.src = 'https://cdn.jsdelivr.net/npm/html2canvas@1.4.1/dist/html2canvas.min.js';
        s1.onload = () => {
          const s2 = document.createElement('script');
          s2.src = 'https://cdn.jsdelivr.net/npm/jspdf@2.5.1/dist/jspdf.umd.min.js';
          s2.onload = () => resolve();
          s2.onerror = () => reject();
          document.head.appendChild(s2);
        };
        s1.onerror = () => reject();
        document.head.appendChild(s1);
      });
    }

    try {
      const marksheetBox = document.getElementById('marksheetBox') as HTMLDivElement;
      const canvas = await (window as any).html2canvas(marksheetBox, {
        scale: 2,
        useCORS: true
      });

      const imgData = canvas.toDataURL('image/png');
      const { jsPDF } = (window as any).jspdf;
      const pdf = new jsPDF('p', 'mm', 'a4');
      const imgWidth = 210; // A4 size width
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
      pdf.save(`Marksheet_${targetIID}.pdf`);
    } catch (err: any) {
      alert('Error downloading PDF: ' + err.message);
    } finally {
      downloadPdfBtn.disabled = false;
      downloadPdfBtn.textContent = 'Download PDF';
    }
  };

  // Run initial loading
  await loadReportCard();
}
